import React, { Component } from 'react';
import { Link, withRouter } from 'react-router';
import _ from 'lodash';
import { Field } from 'redux-form';
import classNames from 'classnames';
import { Grid, Row, Col, Panel, Button, Input, Tabs, Tab, Textarea, Image } from 'react-bootstrap';
import { DisabledSelection } from '../Common/selection';
import DisabledPriceField from '../Common/priceField';
import DisabledAfterAddonField from '../Common/afterAddonField';
import DisabledWeightField from '../Common/weightField';
import Spinner from '../Widgets/spinner';
import { Translate, Localize } from 'react-redux-i18n';

export default class ProductArrayDisabled extends Component {
    constructor() {
        super();
        this.state = {
            // Only show the current Product
            currentProduct: -1
        };
    }

    componentWillMout() {
    }

    getNetWeight(id) {
        const { products } = this.props;
        const index = _.findIndex(products, { 'Product_id': id });
        return parseFloat(products[index].NetWeight);
    }

    getShippingWeight(id) {
        const { products } = this.props;
        const index = _.findIndex(products, { 'Product_id': id });
        return parseFloat(products[index].ShippingWeight);
    }

    // If the priceType is selected to be CIF, calculate the CIF Price.

    getCIFPrice(index) {
        const { priceType, productsValue, totalPrice } = this.props;
        if (priceType == 'CIF' && productsValue[index].TotalPrice && totalPrice != '0.0000') {
            let CIFPrice = parseFloat(this.props.totalCost || 0) * parseFloat(productsValue[index].TotalPrice || 0) / parseFloat(totalPrice);
            CIFPrice = CIFPrice / parseFloat(productsValue[index].Quantity || 0) + parseFloat(productsValue[index].FOBUnitPrice || 0);
            CIFPrice = CIFPrice.toFixed(2);
            return CIFPrice;
        } else return 0;
    }

    productHeader(index){
        const { currentProduct } = this.state;
        const { calculatedProducts, productsValue } = this.props;
        const descriptionClass = classNames({ 'hidden': index == currentProduct}, 'pull-right' )
        return (
            <div  onClick={ (e) => {
                    e.preventDefault();
                    if(index != currentProduct ) this.setState({currentProduct: index});
                    else this.setState({currentProduct: -1});
                }} >
                <div>
                  {index == currentProduct && <label style={{ cursor: "pointer" }} ><Translate value="product_information" /></label>}
                    {index != currentProduct && calculatedProducts[index] &&
                        <label style={{ cursor: "pointer" }} >{calculatedProducts[index].Title }</label>}
                    {index != currentProduct && productsValue && <div className="pull-right" > {productsValue[index].Quantity} </div> }
                </div>
            </div>
        )
    }

    render() {
        const { fields, productNumOptions, productNameOptions, refNumOptions, productsValue, products, calculatedProducts } = this.props;
        return (
            <Row><Col sm={ 12 }>
                <Row><Col sm={ 12 }>
                    {fields.map((Product, index) =>
                        <Panel header={this.productHeader(index)} key={ index }
                               collapsible expanded={index == this.state.currentProduct}>
                            <h4>Production Information</h4>
                            <hr/>
                            <Row>
                                <Col sm={ 5 }>
                                    <Row><Col sm={ 12 }>
                                        <div className="form-group">
                                          <label><Translate value="product_num" /></label>
                                            <Field name={`${Product}.Product_id`} component={DisabledSelection} options={productNumOptions}/>
                                        </div>
                                    </Col></Row>
                                    <Row><Col sm={ 12 }>
                                        <div className="form-group">
                                          <label><Translate value="product_name" /></label>
                                            <Field name={`${Product}.Product_id`} component={DisabledSelection} options={productNameOptions}/>
                                        </div>
                                    </Col></Row>
                                </Col>
                                <Col sm={ 7 }>
                                  <label><Translate value="description" /></label>
                                    <Field name="PickupWarehouse" component="Textarea" className="form-control" style={{ minHeight: '130px' }}/>
                                </Col>
                            </Row>
                            <br/>
                              <h4><Translate value="product_unit_weight_price" /></h4>
                            <hr/>
                              {calculatedProducts[index] && !calculatedProducts[index].Product_id && <h4 className="centerStyle"><Translate value="please_select_a_product" /></h4>}
                            {calculatedProducts[index] && calculatedProducts[index].Product_id &&
                                <div>
                                    <Row>
                                      <label className="col-sm-3 centerStyle" ><Translate value="unit_price" />:</label>
                                        <Col sm={ 9 }>
                                            <Field name={`${Product}.UnitPrice`} component={ DisabledPriceField }/>
                                        </Col>
                                    </Row>
                                    <br/>
                                    <Row>
                                      <label className="col-sm-3 centerStyle" ><Translate value="convert_item_price" />:</label>
                                        <Col sm={ 9 }>
                                            <Field name={`${Product}.ConvertItemPrice`} component={ DisabledPriceField } V={this.getCIFPrice(index)}/>
                                        </Col>
                                    </Row>
                                    <br/>
                                    <Row>
                                      <label className="col-sm-3 centerStyle" ><Translate value="quantity" />:</label>
                                        <Col sm={ 9 }>
                                            <Field name={`${Product}.Quantity`} component={ DisabledAfterAddonField }/>
                                        </Col>
                                    </Row>
                                    <br/>
                                    <Row>
                                      <label className="col-sm-3 centerStyle" ><Translate value="unit" />:</label>
                                        <Col sm={ 9 }>
                                            <Field name={`${Product}.Unit`} component={ DisabledAfterAddonField }/>
                                        </Col>
                                    </Row>
                                    <br/>
                                    <Row>
                                      <label className="col-sm-3 centerStyle" ><Translate value="total_price" />:</label>
                                        <Col sm={ 9 }>
                                            {calculatedProducts[index] &&
                                                <div>
                                                    <Field name={`${Product}.TotalPrice`}
                                                        component={ DisabledPriceField }
                                                        V={calculatedProducts[index].TotalPrice }/>
                                                </div> }
                                        </Col>
                                    </Row>
                                    <br/>
                                    <Row>
                                      <label className="col-sm-3 centerStyle" ><Translate value="total_net_weight" />:</label>
                                        <Col sm={ 9 }>
                                            {calculatedProducts[index] &&
                                                <div>
                                                    <Field name={`${Product}.TotalNetWeight`}
                                                        component={ DisabledWeightField }
                                                        V={calculatedProducts[index].TotalNetWeight }/>
                                                </div> }
                                        </Col>
                                    </Row>
                                    <br/>
                                    <Row>
                                      <label className="col-sm-3 centerStyle" ><Translate value="total_shipping_weight" />:</label>
                                        <Col sm={ 9 }>
                                            {calculatedProducts[index] &&
                                                <div>
                                                    <Field name={`${Product}.TotalShippingWeight`}
                                                        component={ DisabledWeightField }
                                                        V={calculatedProducts[index].TotalShippingWeight }/>
                                                </div> }
                                        </Col>
                                    </Row>
                                    <br/>
                                    <Row>
                                      <label className="col-sm-3 centerStyle" ><Translate value="et_sale_price" />:</label>
                                        <Col sm={ 9 }>
                                            <Field name={`${Product}.EstSalePrice`} component={ DisabledPriceField }/>
                                        </Col>
                                    </Row>
                                </div>}
                        </Panel>) }
                    <Row>
                    </Row>
                </Col></Row>
            </Col></Row>
        )
    }
}



// WEBPACK FOOTER //
// ./master/jsx/components/Purchase/productArrayDisabled.jsx